import React, { useState, useEffect, useContext } from "react";
import '../../css/PropertyList.css';
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { fetchSubLocalities } from '../../redux/subLocalitySlice';
import Advertisement from "../Advertisement";
import { AppContext } from '../../context/AppContext';
import PropertyListDemo from "./PropertyListDemo";
import axios from "axios";

const PropertyListLocality = () => {
  const dispatch = useDispatch();
  const { user } = useContext(AppContext);
  const location = useLocation();
  const [locationId,setLocationId] = useState('');
  const lastSegment = location.pathname.split("/").pop();
  const parts = lastSegment.split("-");
  const [prefix, setPrefix] = useState(parts[parts.length - 2]);
  const [cId, setCId] = useState(parts[parts.length - 1]);

  const serviceDefault = location.pathname.split("/")[1];
  const typeDefault = location.pathname.split("/")[2];
  const { service = serviceDefault, type = typeDefault } = location.state || {};

  const serviceCategory = ['buy', 'lease'].includes(type) ? type : '';
  const { subLocalities } = useSelector((state) => state.subLocalities);




   const handleLocationId = (id) => {
       setLocationId(id);
    };
  // const [fullUrl, setFullUrl] = useState('');
  // const [isLoading, setIsLoading] = useState(true);
  // const [preDefineFilters, setPreDefineFilters] = useState({});

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (typeof prefix === 'undefined' || prefix === undefined || prefix === null || prefix === '') {
  //       try {
  //         const getRequestData = await axios.post(
  //           `${process.env.REACT_APP_BASE_URL}/shortIdToUrl`,
  //           { lastSegment }
  //         );

  //         const response = getRequestData.data;
  //         if (response.status === 'success' && response.data) {
  //           const data = response.data;
  //           setPrefix(data?.category || '');
  //           setCId(data?.location_id || '');
  //           setFullUrl(`${data?.path}?${data?.queryString}`);
  //           setPreDefineFilters(JSON.parse(data?.filters || {}));
  //         }
  //       } catch (error) {
  //         console.error('Error fetching short ID data:', error);
  //       }
  //     }

  //     setIsLoading(false);
  //   };

  //   fetchData();
  // }, [prefix, lastSegment]);

  const path = {
    home: `getListings/${cId}?service=sell&category=residential`,
    buy: `getListings/${cId}?service=sell&category=residential`,
    rent: `getListings/${cId}?service=rent&category=residential`,
    plot: `getListings/${cId}?service=sell&category=residential`,
    commercialbuy: `getListings/${cId}?service=sell&category=commercial`,
    commerciallease: `getListings/${cId}?service=rent&category=commercial`,
    living: `getListings/${cId}?service=rent&category=living`,
  };
  const path1 = {
    home: `getListings/${locationId}?service=sell&category=residential`,
    buy: `getListings/${locationId}?service=sell&category=residential`,
    rent: `getListings/${locationId}?service=rent&category=residential`,
    plot: `getListings/${locationId}?service=sell&category=residential`,
    commercialbuy: `getListings/${locationId}?service=sell&category=commercial`,
    commerciallease: `getListings/${locationId}?service=rent&category=commercial`,
    living: `getListings/${locationId}?service=rent&category=living`,
  };

  useEffect(() => {
    if (cId && prefix) {
      dispatch(fetchSubLocalities([prefix,cId]));
    }
  }, [cId, prefix]);


//  localStorage.setItem("feature_clicked","property_detail:corner_plot,east,property_type:plot") 
  // if (isLoading) return null;

  return (
    <div className="proplstdisp allistbotmr mt-5">
      <div className="mob">
        <Advertisement param={subLocalities} service={service} prefix={prefix} user={user} />
      </div>

      {subLocalities && (
        <PropertyListDemo
          url = {locationId ? path1[`${service}${serviceCategory}`] : path[`${service}${serviceCategory}`]}
          subLocalities={subLocalities}
          cId={cId}
          prefix={prefix}
          user={user}
          service={`${service}${serviceCategory}`}
         handleLocationId={handleLocationId}
          // preDefineFilters={preDefineFilters}
        />
      )}

      <div className="desk adsidebarbx">
        <Advertisement param={subLocalities} service={service} prefix={prefix} user={user} />
      </div>
    </div>
  );
};

export default PropertyListLocality;
